import { render, staticRenderFns } from "./AssessmentRefereeData.vue?vue&type=template&id=28182ade"
import script from "./AssessmentRefereeData.vue?vue&type=script&lang=js"
export * from "./AssessmentRefereeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports